
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
	mdiFolderCheckOutline,
	mdiRunFast,
	// mdiAccountWrench,
	mdiAccountDetails,
	mdiViewDashboard,
	mdiAvTimer,
	mdiAccountAlert,
	mdiBusDoubleDecker,
  mdiHumanMaleBoard,
	mdiOfficeBuilding,
	mdiAccountConvert,
	mdiCalendar,
	mdiSoccer,
	mdiQrcodeScan,
	mdiAccountSchool,
	mdiCog,
	mdiAccount,
  mdiAccountCheck,
	mdiSchool,
	mdiComment,
	mdiGoogleClassroom,
	mdiBookshelf,
	mdiCashMultiple,
	mdiFlag,
	mdiCalendarAccount,
	mdiAccountChild,
	mdiDoorOpen,
	mdiNeedle,
	mdiArrowUpBold,
  mdiTimelineOutline,
	mdiAccountOutline,
	mdiAccountCircle,
	mdiBookOpenVariant,
	mdiFaceAgent,
	mdiAccountGroup,
	mdiCalendarCursor,
	mdiClipboardAccount,
	mdiClipboardAccountOutline,
	mdiPuzzle,
	mdiAccountArrowLeft,
	mdiAccountArrowLeftOutline,
	mdiConsoleNetworkOutline,
	mdiTimetable,
	mdiCalendarMonth,
  mdiClipboardText,
	mdiBookOpenPageVariant,
	mdiHammerScrewdriver,
	mdiBookPlusMultiple,
	mdiFormatLetterMatches,
	mdiFormatListBulletedType,
	mdiNotebookEdit,
	mdiNumeric9BoxMultiple,
	mdiTimelineClockOutline,
	mdiWatermark,
	mdiAccountMultiplePlus,
	// mdiPen,
	// mdiChartBar,
	mdiTrophyOutline
  // mdiNumeric10CircleOutline
} from '@mdi/js'

const menuAcademicAll = [
  {
    to: '/comboard-dashboard',
    icon: mdiViewDashboard,
    label: 'sidebar.dashboard'
  },
  {
    label: 'Master',
    subLabel: 'Submenus Master',
    icon: mdiCog,
    menu: [
      {
        to: '/academic-year',
        label: 'Academic Year',
        icon: mdiCalendar
      },
      {
        to: '/financial-year',
        label: 'Financial Year',
        icon: mdiCalendarMonth
      },
      {
        to: '/academic-batch',
        label: 'Academic Batch',
        icon: mdiCalendarAccount
      },
      {
        to: '/department',
        label: 'Department',
        icon: mdiOfficeBuilding
      },
      {
        to: '/semester',
        label: 'Semester',
        icon: mdiFlag
      },
      {
        to: '/phase',
        label: 'Phase',
        icon: mdiTimelineOutline
      },
      {
        to: '/level',
        label: 'Level',
        icon: mdiArrowUpBold
      },
      {
        to: '/resignation-reason',
        label: 'Resignation Reason',
        icon: mdiBookOpenVariant
      },
      {
        to: '/class',
        label: 'Class',
        icon: mdiGoogleClassroom,
        updateMark: true
      },
      {
        to: '/work-unit',
        label: 'Work Unit',
        icon: mdiOfficeBuilding,
        updateMark: true
      },
      {
        to: '/shift',
        label: 'Shift',
        icon: mdiAccountConvert,
        updateMark: true
      },
      // {
      // 	to: '/extracuricular',
      // 	label: 'Extracuricular',
      // 	icon: mdiSoccer
      // },
      {
        to: '/vaccine',
        label: 'Vaccine',
        icon: mdiNeedle
      },
      {
        to: '/comment',
        label: 'Comment',
        icon: mdiComment
      },
      {
        to: '/batch-registration',
        label: 'Batch Registration',
        icon: mdiCalendarCursor
      },
      {
        to: '/major',
        label: 'Major',
        icon: mdiSchool
      },
      {
        to: '/major-date',
        label: 'Event',
        icon: mdiSchool
      },
      {
        to: '/master-tag',
        label: 'Tag',
        icon: mdiFlag
      }
    ]
  },

  // {
  // 	label: 'Course Achievement',
  // 	to: '/coursework-achievement',
  // 	icon: mdiTrophyOutline
  // },
  // {
  // 	label: 'Master Course',
  // 	subLabel: 'Coursework Master',
  // 	icon: mdiViewModule,
  // 	menu: [
  // 		{
  // 			to: '/coursework',
  // 			label: 'Coursework',
  // 			icon: mdiBookEducationOutline
  // 		},
  // 		{
  // 			to: '/price-group',
  // 			label: 'Price Group',
  // 			icon: mdiTagMultiple
  // 		},
  // 		{
  // 			to: '/price-list',
  // 			label: 'Price List',
  // 			icon: mdiCurrencyUsd
  // 		},
  // 		{
  // 			to: '/non-academic-activity',
  // 			label: 'Non-Academic Activities',
  // 			icon: mdiRunFast
  // 		}
  // 	]
  // },
  // {
  // 	label: 'Comboard',
  // 	subLabel: 'Submenus Comboard',
  // 	icon: mdiComment
  // },
  {
    label: 'Candidates',
    subLabel: 'Submenus Candidates',
    icon: mdiAccountChild,
    menu: [
      {
        to: '/new-batch-registration',
        label: 'New Batch Registration',
        icon: mdiDoorOpen
      },
      {
        to: '/candidates-group',
        label: 'Candidates Group',
        icon: mdiAccountOutline
      },
      {
        to: '/candidate',
        label: 'Candidate',
        icon: mdiAccountOutline
      },
      // {
      // 	to: '/candidate-doc',
      // 	label: 'Candidate Documents',
      // 	icon: mdiAccountGroup
      // },
      {
        to: '/candidates-placement',
        label: 'Candidates Placement',
        icon: mdiAccountOutline
      }
    ]
  },
  {
    label: 'Student',
    subLabel: 'Submenus Student',
    icon: mdiAccountCircle,
    menu: [
      {
        to: '/students',
        label: 'Students',
        icon: mdiAccountGroup
      },
      // {
      // 	to: '/student-doc',
      // 	label: 'Student Documents',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/parent-user',
      // 	label: 'Parents',
      // 	icon: mdiAccount
      // },
      // {
      // 	to: '/',
      // 	label: 'Users',
      // 	icon: mdiAccountMultiple
      // },
      {
        to: '/non-academic-activity',
        label: 'Non-Academic Activities',
        icon: mdiRunFast
      },
      {
        label: 'Student Achievement',
        to: '/student-achievement',
        icon: mdiTrophyOutline
      },
      {
        to: '/class-transfer',
        label: 'Class Transfer',
        icon: mdiAccountMultiplePlus
      },
      {
        to: '/student-resignation',
        label: 'Resignation',
        icon: mdiAccountGroup
      },
      {
        to: '/graduation',
        label: 'Graduation',
        icon: mdiAccountSchool
      }
    ]
  },
  {
    label: 'Parents',
    to: '/parent-user',
    icon: mdiAccount
  },
  // {
  // 	label: 'Generate',
  // 	to: '/generate-userid',
  // 	icon: mdiAccountCircle
  // },
  {
    label: 'Employee',
    subLabel: 'Employee',
    icon: mdiAccountCircle,
    menu: [
      {
        to: '/employee',
        label: 'Employees',
        icon: mdiAccount
      },
      {
        to: '/employee-daily-attendance',
        label: 'Employee Daily Attendance',
        icon: mdiAccountCheck
      },
      {
        to: '/employee-special-assignments',
        label: 'Special Employee Assignments',
        icon: mdiClipboardAccountOutline
      },
      {
        to: '/employee-attendance-report',
        label: 'Employee Attendance Report',
        icon: mdiAccountCheck
      }
    ]
  },
  {
    label: 'Subject',
    subLabel: 'Submenus Subject',
    icon: mdiBookOpenVariant,
    menu: [
      {
        to: '/subject',
        label: 'Subject',
        icon: mdiBookshelf
      },
      {
        to: '/subject-group',
        label: 'Subject Group',
        icon: mdiBookOpenPageVariant
      },
      {
        to: '/learning-method',
        label: 'Learning Method',
        icon: mdiBookPlusMultiple
      },
      {
        to: '/grading-master',
        label: 'Grading Master',
        icon: mdiHammerScrewdriver
      },
      {
        to: '/grading-aspects',
        label: 'Grading Aspects',
        icon: mdiHammerScrewdriver
      },
      {
        to: '/aspect-academic-year',
        label: 'Aspect Academic Year',
        icon: mdiCalendarMonth
      },
      {
        to: '/aspect-assignment-level',
        label: 'Aspect Assignment Level',
        icon: mdiClipboardText
      },
      {
        to: '/assignment-type',
        label: 'Assignment Type',
        icon: mdiFormatListBulletedType
      },
      {
        to: '/grading-rule',
        label: 'Grading Criteria',
        icon: mdiFormatLetterMatches
      },
      {
        to: '/grading-rule-level',
        label: 'Grading Criteria P5',
        icon: mdiFormatLetterMatches
      },
      {
        to: '/final-score-rule',
        label: 'Final Score Rule',
        icon: mdiNumeric9BoxMultiple
      },
      {
        to: '/scoreminimum',
        label: 'Passing Grade',
        icon: mdiNumeric9BoxMultiple
      },
      {
        to: '/syllabus',
        label: 'Syllabus',
        icon: mdiNotebookEdit
      },
      {
        to: '/teaching-time-plan',
        label: 'Teaching Timeplan',
        icon: mdiTimelineClockOutline
      },
      {
        to: '/lesson-plan',
        label: 'Lesson Plan',
        icon: mdiPuzzle
      },
      {
        to: '/lesson-plan-summary',
        label: 'Lesson Plan Summary',
        icon: mdiPuzzle
      },
      {
        to: '/student-paralel-subject',
        label: 'Student Parallel Subject',
        icon: mdiAccountDetails
      },
      {
        to: '/student-select-subject',
        label: 'Student Subject Selection',
        icon: mdiAccountDetails
      }
    ]
  },
  {
    label: 'Extracuricular',
    subLabel: 'Submenus Extracuricular',
    icon: mdiSoccer,
    menu: [
      {
        to: '/extracuricular',
        label: 'Extracuricular',
        icon: mdiSoccer
      },
      {
        to: '/extracuricular-group',
        label: 'Extracuricular Group',
        icon: mdiSoccer
      },
      {
        to: '/extracuricular-student',
        label: 'Student Extracuricular',
        icon: mdiAccountDetails
      },
      {
        to: '/extracuricular-student-select',
        label: 'Student Extracuricular Selection',
        icon: mdiAccountDetails
      }
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ]
  },
  {
    label: 'Teacher',
    subLabel: 'Submenus Teacher',
    icon: mdiClipboardAccount,
    menu: [
      {
        to: '/teacher',
        label: 'Teacher',
        icon: mdiClipboardAccountOutline
      },
      {
        to: '/teacher-extracuricular',
        label: 'Extracurricular Teacher',
        icon: mdiSoccer
      },
      {
        to: '/teacher-note',
        label: 'Teacher Note',
        icon: mdiAccountDetails
      },
      {
        to: '/scan-asset',
        label: 'Scan Asset',
        icon: mdiQrcodeScan
      },
      {
        to: '/scan-asset-location',
        label: 'Scan Asset Location',
        icon: mdiQrcodeScan
      }
      // {
      // 	to: '/teacherjournal',
      // 	label: 'Teacher Journal',
      // 	icon: mdiFileDocument
      // }
    ]
  },
  {
    label: 'Transaction',
    subLabel: 'Transaction',
    icon: mdiCashMultiple,
    menu: [
      {
        to: '/transaction-type',
        label: 'Transaction Type',
        icon: mdiCashMultiple
      },
      {
        to: '/transaction-group',
        label: 'Transaction Group',
        icon: mdiCashMultiple
      }
    ]
  },
  // {
  // 	label: 'Incomes',
  // 	subLabel: 'Payment',
  // 	icon: mdiAccountCash,
  // 	menu: [
  // 		{
  // 			to: '/paymenttransaction',
  // 			label: 'Payment',
  // 			icon: mdiCashMultiple
  // 		},
  // 		{
  // 			to: '/income',
  // 			label: 'Income',
  // 			icon: mdiCashMultiple
  // 		}
  // 	]
  // },
  {
    label: 'Permission Request',
    subLabel: 'Submenus Teacher',
    icon: mdiFaceAgent,
    menu: [
      {
        to: '/permissions',
        label: 'Permissions',
        icon: mdiFaceAgent
      },
          {
        to: '/permission-reason',
        label: 'Permission Reason',
        icon: mdiFaceAgent
      }
    ]
  },
  {
    label: 'Schedule',
    subLabel: 'Submenus Schedule',
    icon: mdiTimetable,
    menu: [
        {
        to: '/school-time',
        label: 'School Time',
        icon: mdiAvTimer
      },
      {
        to: '/study-time',
        label: 'Study Time',
        icon: mdiAvTimer
      },
      {
        to: '/schedule',
        label: 'Schedule',
        icon: mdiTimetable
      },
      {
        to: '/extracuricular-schedule',
        label: 'Extracuricular Schedule',
        icon: mdiTimetable
      },
      {
        to: '/calendar',
        label: 'Calendar',
        icon: mdiCalendarMonth
      }
    ]
  },
  {
    label: 'School Events',
    to: '/school-events',
    icon: mdiCalendar
  },
  {
    label: 'Attendance',
    subLabel: 'Submenus Attendance',
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: '/daily-attendance',
        label: 'Daily Attendance',
        icon: mdiConsoleNetworkOutline
      },
      {
        to: '/regular-subject-attendance',
        label: 'Regular Subject',
        icon: mdiAccountArrowLeftOutline
      },
      {
        to: '/parallel-subject',
        label: 'Parallel Subject',
        icon: mdiAccountArrowLeftOutline
      },
      {
        to: '/report-attendance-daily',
        label: 'Daily Attendance Report',
        icon: mdiAccountAlert
      },
      {
        to: '/summary-report',
        label: 'Summary Report',
        icon: mdiAccountAlert
      },
      {
        to: '/assignment-special',
        label: 'Special Assignment',
        icon: mdiBusDoubleDecker
      },
      {
        to: '/subject-attendance',
        label: 'Regular Subject Attendance',
        icon: mdiHumanMaleBoard
      }
    ]
  },
  {
    label: 'Subject Assessment',
    subLabel: 'Submenus Subject Assessment',
    icon: mdiSchool,
    menu: [
      {
        to: '/lesson-assessment-regular',
        label: 'Regular',
        icon: mdiSchool
      },
      // {
      //   to: '/lesson-assessment-regular-subtopic',
      //   label: 'Regular by Sub Topic',
      //   icon: mdiSchool
      // },
      {
        to: '/lesson-assessment-parallel',
        label: 'Parallel',
        icon: mdiSchool
      },
      {
        to: '/ledger-homeroom-attidude',
        label: 'Homeroom Ledger Attidude',
        icon: mdiSchool
      },
      {
        to: '/ledger-homeroom-teacher',
        label: 'Homeroom Ledger',
        icon: mdiSchool
      },
      {
        to: '/extracuricular-score',
        label: 'Extracuricular Score',
        icon: mdiSchool
      }
      // {
      //   to: '/aspect-assignment-score',
      //   label: 'Aspect Assignment Score',
      //   icon: mdiNumeric10CircleOutline
      // }
    ]
  },
  {
    label: 'Raport',
    to: '/student-raport',
    icon: mdiSchool
  },
  {
    label: 'Roles',
    subLabel: 'Roles',
    icon: mdiFaceAgent,
    menu: [
      {
        to: '/role',
        label: 'Role',
        icon: mdiFaceAgent
      },
      {
        to: '/role-group',
        label: 'Role Group',
        icon: mdiFaceAgent
      }
    ]
  },
  {
    label: 'Settings',
    subLabel: 'Submenus Settings',
    icon: mdiCog,
    menu: [
      {
        to: '/schoolidentity',
        label: 'School Identity',
        icon: mdiSchool
      },
      {
        to: '/branch',
        label: 'Branch',
        icon: mdiWatermark
      },
      {
        to: '/users',
        label: 'Users',
        icon: mdiAccount
      },
      {
        to: '/general-setting',
        label: 'General Setting',
        icon: mdiCog
      },
      {
        to: '/active-docmag',
        label: 'Activate Management',
        icon: mdiFolderCheckOutline
      },
      // {
      //   to: '/unapprove-mechanism',
      //   label: 'Unapprove Mechanism',
      //   icon: mdiAccountWrench
      // },
      // {
      //   to: '/settingattendance',
      //   label: 'Setting Attendance',
      //   icon: mdiPen
      // },
      // {
      //   to: '/settingspeed',
      //   label: 'Chart & Analysis Setting',
      //   icon: mdiChartBar
      // },
      // {
      //   to: '/settingtimeout',
      //   label: 'Setting Major & Cross Major',
      //   icon: mdiTimelineClockOutline
      // },
      // {
      //   to: '/settingextracuricular',
      //   label: 'Setting Extracuricular',
      //   icon: mdiTimelineClockOutline
      // },
      // {
      //   to: '/settingmodule',
      //   label: 'Setting Module',
      //   icon: mdiBookOpenPageVariant
      // },
      {
        to: '/template-announcement',
        label: 'Template Announcement',
        icon: mdiSchool
      }
    ]
  }
]
export default menuAcademicAll
